module.exports = __webpack_public_path__ + "img/cww_14.6f062ca0.jpg";